const casesInitialSortingOrder = [
  {
    // key: 'csUid',
    key: 'lastModified',
    desc: true,
  },
];

export default casesInitialSortingOrder;
